<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      @if (reservationGlobalFlag) {
        <div class="card">
          <div class="card-header">
            <span><i class="fa s-icon-list"></i> パーソナルトレーニング予約一覧</span>
          </div>
          <div class="card-body">
            <div class="row form-group">
              <div class="col-md-12">
                <button class="form-group btn btn-primary text-white" type="button"
                        data-toggle="modal" data-target="#newReservationModal"
                        (click)="initNewReserve()">
                  <span class="material-symbols-outlined" style="font-size: 1rem; vertical-align: sub;">event_upcoming</span>
                  &nbsp;新規予約
                </button>
              </div>
            </div>

            <ul class="pagination pull-right">
              @if (filteredItems.length > 0 && pageCount > columnWidth) {
                <li [class.disabled]="showStart === 0" class="page-item">
                  <a class="page-link" href="" aria-label="Previous" (click)="pagerClick(0); $event.preventDefault()">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li [class.disabled]="currentPage === 0" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(currentPage - 1); $event.preventDefault()">
                    <span>prev</span>
                  </a>
                </li>
              }
              @if (filteredItems.length > 0) {
                @for (pager of pagerPages; track pager) {
                  @if (pager >= showStart && pager <= showEnd) {
                    <li [class.active]="pager === currentPage">
                      <a href="" class="pager-item" (click)="pagerClick(pager); $event.preventDefault()">{{ pager + 1 }}</a>
                    </li>
                  }
                }
              }
              @if (filteredItems.length > 0 && pageCount > columnWidth) {
                <li [class.disabled]="currentPage >= pageCount - 1" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(currentPage + 1); $event.preventDefault()">
                    <span>next</span>
                  </a>
                </li>
                <li [class.disabled]="showEnd >= pageCount - 1" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(pageCount - 1); $event.preventDefault()">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              }
            </ul>

            @if (items !== null && items.length === 0) {
              <label>現在、ご予約はありません。</label>
            }

            <div class="table-responsive">
              @if (showTable && filteredItems.length > 0) {
                <table class="table table-bordered table-sm table-hover table-ptb-0">
                  <thead>
                    <tr>
                      <th width="80px">予約状況</th>
                      <th class="d-md-none d-table-cell" width="200px">予約内容</th>
                      <th class="d-none d-md-table-cell" width="180px">メニュー</th>
                      <th class="d-none d-md-table-cell" width="160px">開始時間</th>
                      <th class="d-none d-md-table-cell" width="70px">所要時間</th>
                      <th class="d-none d-md-table-cell" width="70px">金額</th>
                      <th class="d-none d-md-table-cell" width="120px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of pagedItems; track item.id) {
                      <tr>
                        <td>
                          <div class="border-0 d-flex flex-column bd-highlight text-center">
                            <div class="pb-1"
                                 [class.text-warning]="item.status === 0"
                                 [class.text-info]="item.status === 1"
                                 [class.text-success]="item.status === 2"
                                 [class.text-secondary]="item.status === 3">
                              <span class="material-symbols-outlined">
                                @if (item.status === 0) { event_upcoming }
                                @if (item.status === 1) { today }
                                @if (item.status === 2) { event_available }
                                @if (item.status === 3) { event_busy }
                              </span>
                            </div>
                            @if (item.status === 0) { <small>予約受付</small> }
                            @if (item.status === 1) { <small>予約確定</small> }
                            @if (item.status === 2) { <small>実施済み</small> }
                            @if (item.status === 3) { <small>キャンセル</small> }
                          </div>
                        </td>
                        <td class="d-md-none d-table-cell" style="padding: 1rem 0.75rem">
                          <span class="d-block">{{ item.reservationMenu?.menuName }}</span>
                          <span class="d-block">{{ formatCurrency(item.amount) }}</span>
                          <button type="button" class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                                  style="margin-top: 1rem !important"
                                  data-toggle="modal" data-target="#reservationModal"
                                  (click)="setDetail(item)" title="編集">
                            <span class="material-symbols-outlined" style="font-size: 1rem; vertical-align: sub;">info</span>
                            予約詳細
                          </button>
                          <hr>
                          <span class="d-block">開始日時: </span>
                          <span class="d-block" style="padding-left: 0.5rem">{{ item.formattedStartedAt }}</span>
                          <span class="d-block" style="padding-left: 0.5rem">({{ item.reservationMenu?.requiredTime }}分)</span>
                        </td>
                        <td class="d-none d-md-table-cell">{{ item.reservationMenu?.menuName }}</td>
                        <td class="d-none d-md-table-cell">{{ item.formattedStartedAt }}</td>
                        <td class="text-right d-none d-md-table-cell">{{ item.reservationMenu?.requiredTime }}分</td>
                        <td class="text-right d-none d-md-table-cell">{{ formatCurrency(item.amount) }}</td>
                        <td class="text-center d-none d-md-table-cell">
                          <button type="button" class="mt-2 mb-2 pt-2 pb-2 btn btn-primary btn-sm text-white"
                                  data-toggle="modal" data-target="#reservationModal"
                                  (click)="setDetail(item)" title="編集">
                            <span class="material-symbols-outlined" style="font-size: 1rem; vertical-align: sub;">info</span>
                            予約詳細
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>

            <ul class="pagination pull-right">
              @if (filteredItems.length > 0 && pageCount > columnWidth) {
                <li [class.disabled]="showStart === 0" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(0); $event.preventDefault()">
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                <li [class.disabled]="currentPage === 0" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(currentPage - 1); $event.preventDefault()">
                    <span>prev</span>
                  </a>
                </li>
              }
              @if (filteredItems.length > 0) {
                @for (pager of pagerPages; track pager) {
                  @if (pager >= showStart && pager <= showEnd) {
                    <li [class.active]="pager === currentPage">
                      <a href="" class="pager-item" (click)="pagerClick(pager); $event.preventDefault()">{{ pager + 1 }}</a>
                    </li>
                  }
                }
              }
              @if (filteredItems.length > 0 && pageCount > columnWidth) {
                <li [class.disabled]="currentPage >= pageCount - 1" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(currentPage + 1); $event.preventDefault()">
                    <span>next</span>
                  </a>
                </li>
                <li [class.disabled]="showEnd >= pageCount - 1" class="page-item">
                  <a class="page-link" href="" (click)="pagerClick(pageCount - 1); $event.preventDefault()">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- 予約詳細 Modal -->
  <div class="modal fade" id="reservationModal" tabindex="-1" role="dialog"
       aria-labelledby="reservationModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="width: 95%;max-width: 800px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="reservationModalLabel"><i class="fa fa-calendar"></i>&nbsp;予約詳細</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate>
          <div class="modal-body">
            <div class="row">
              @if (modalControl.showDetail) {
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 col-form-label">
                      <div class="d-flex justify-content-end" style="gap: 1rem;">
                        @if (selectReservation.isRemovable) {
                          <button class="btn btn-outline-secondary" type="button" (click)="showConfirm()">
                            <span class="material-symbols-outlined" style="vertical-align: bottom;">delete</span>&nbsp;予約キャンセル
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約日時</label>
                    <div class="col-md-8"><label>{{ selectReservation.displayStartedAt }}</label></div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">終了予定時刻</label>
                    <div class="col-md-8"><label>{{ selectReservation.displayEndedAt }}</label></div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">所要時間</label>
                    <div class="col-md-8"><label>{{ selectReservation.reservationMenu?.requiredTime }}分</label></div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">メニュー名</label>
                    <div class="col-md-8"><label>{{ selectReservation.reservationMenu?.menuName }}</label></div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">金額</label>
                    <div class="col-md-8"><label>{{ formatCurrency(selectReservation.amount) }}</label></div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約状況</label>
                    <div class="col-md-8 col-form-label">
                      @if (selectReservation.status === 0) { <label>予約受付</label> }
                      @if (selectReservation.status === 1) { <label>予約確定</label> }
                      @if (selectReservation.status === 2) { <label>実施済み</label> }
                      @if (selectReservation.status === 3) { <label>キャンセル</label> }
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約受付日時</label>
                    <div class="col-md-8"><label>{{ selectReservation.displayCreatedAt }}</label></div>
                  </div>
                </div>
              }
              @if (modalControl.showConfirm) {
                <div class="col-md-12">
                  <div class="row">
                    <label class="col-md-12">予約をキャンセルします。よろしいですか。</label>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" data-dismiss="modal">
              <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
            </button>
            @if (selectReservation.isRemovable && modalControl.showConfirm) {
              <button class="btn btn-danger" type="button" (click)="remove()" data-dismiss="modal">
                <span class="material-symbols-outlined" style="vertical-align: bottom;">delete</span>&nbsp;キャンセルする
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- 新規予約 Modal -->
  <div class="modal fade" id="newReservationModal" tabindex="-1" role="dialog"
       aria-labelledby="newReservationModalLabel" style="padding-left: 15px" aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width: 1200px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="newReservationModalLabel"><i class="fa fa-calendar"></i>&nbsp;新規予約</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #reservationForm="ngForm">
          <div class="modal-body">
            <div class="row">

              <div class="col-md-12" [hidden]="!modalControl.isSelectMenu">
                  @if (menuItems.length === 0) {
                    <label class="col-md-12">現在予約可能なトレーニングはありません。</label>
                  }
                  <div class="card-deck">
                    @for (menu of menuItems; track menu.id) {
                      <div class="card">
                        <img class="card-img-top" [src]="menu.uploadedImg || 'img/pt_logo.webp'" alt="Card image cap">
                        <div class="card-body">
                          <div>
                            <h5 class="card-title">{{ menu.menuName }}</h5>
                            <h6 class="card-subtitle text-muted">{{ menu.requiredTime }}分 {{ formatCurrency(menu.incTaxAmount) }}</h6>
                          </div>
                          <pre class="card-text" style="white-space: pre-wrap;">{{ menu.description }}</pre>
                          <button class="btn btn-outline-info" type="button" (click)="selectMenu(menu)">このプランを選択する</button>
                        </div>
                      </div>
                    }
                  </div>
              </div>

              <div [hidden]="!modalControl.isSelectTime">
                <div class="card-body">
                  <div #calendarElement id="calendar"></div>
                </div>
              </div>

              <div class="col-md-12" [hidden]="!modalControl.isConfirm">
                  <div class="col-md-12 text-right">
                    <button class="btn btn-outline-secondary" type="button" (click)="modalBack()">
                      <span class="material-symbols-outlined align-bottom">undo</span>&nbsp;戻る
                    </button>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">予約日時</label>
                    <div class="col-md-8"><label>{{ selectReservation.displayStartedAt }}</label></div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">終了予定時刻</label>
                    <div class="col-md-8"><label>{{ selectReservation.displayEndedAt }}</label></div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">所要時間</label>
                    <div class="col-md-8"><label>{{ selectReservation.requiredTime }}分</label></div>
                  </div>
                  <hr>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">メニュー名</label>
                    <div class="col-md-8"><label>{{ selectReservation.menuName }}</label></div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">金額</label>
                    <div class="col-md-8"><label>{{ formatCurrency(selectReservation.amount) }}</label></div>
                  </div>
                  <br>
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">連絡事項</label>
                    <div class="col-md-8">
                      <textarea [(ngModel)]="selectReservation.note" name="note"
                                class="w-100 form-control" rows="4" sfMaxLength="255"
                                placeholder="連絡事項がございましたら、ご入力ください。"></textarea>
                    </div>
                  </div>
                  <br>
                  <div class="form-group row">
                    <label class="col-md-12 col-form-label">上記の内容で予約を受け付けます。よろしいですか？</label>
                    <label class="col-md-12 col-form-label">
                      <div class="d-flex align-items-start" style="gap: 0.5rem">
                        <span>※</span>
                        <label>当日キャンセルには所定のキャンセル料が発生する場合があります。<br/>詳しくは店舗までお問い合わせください。</label>
                      </div>
                    </label>
                  </div>
                  <br>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" data-dismiss="modal">
              <span class="material-symbols-outlined" style="vertical-align: bottom;">cancel</span>&nbsp;閉じる
            </button>
            @if (selectReservation && modalControl.isConfirm) {
              <button class="btn btn-success" type="button" (click)="save()" data-dismiss="modal" [disabled]="reservationForm.invalid">
                <span class="material-symbols-outlined" style="vertical-align: bottom;">check_circle</span>&nbsp;予約する
              </button>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
